import { Dialog, Paper, Box } from '@mui/material';
import AppButton from '../../../../components/ui/AppButton';

const DeleteRewardDialog = ({ open, onClose, onConfirm, data, isLoading }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <Paper sx={{ minWidth: '450px', backgroundColor: 'white', padding: '2rem' }}>
        <Box sx={{ textAlign: 'center', letterSpacing: '0.5px', marginBottom: '10px' }}>
          <Box component="span" sx={{ fontSize: '1.5rem', fontWeight: '500' }}>
            คุณต้องการลบรางวัล
          </Box>
          <br />
          <Box component="span" sx={{ fontSize: '1.75rem', color: 'red', fontWeight: 'bold' }}>
            {data.name}
          </Box>
          <br />
          <Box component="span" sx={{ fontSize: '1.5rem' }}>
            ใช่หรือไม่
          </Box>
        </Box>

        {/* Action Button */}
        <Box
          sx={{
            paddingTop: '2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '50px',
          }}
        >
          <AppButton
            variant="text"
            sx={{
              width: '120px',
              height: '45px',
              borderRadius: '8px',
              backgroundColor: '#e5e5e5',
              color: '#262626',
              fontSize: '1.25rem',

              '&:hover': {
                backgroundColor: '#e5e5e5',
                color: '#262626',
                opacity: '.85',
              },
            }}
            onClick={onClose}
          >
            ยกเลิก
          </AppButton>
          <AppButton
            variant="text"
            disabled={isLoading}
            sx={{
              width: '120px',
              height: '45px',
              borderRadius: '8px',
              backgroundColor: '#E1000C',
              color: 'white',
              fontSize: '1.25rem',

              '&:hover': {
                backgroundColor: '#E1000C',
                color: 'white',
                opacity: '.85',
              },
            }}
            onClick={() => onConfirm(data)}
          >
            ตกลง
          </AppButton>
        </Box>
      </Paper>
    </Dialog>
  );
};

export default DeleteRewardDialog;
